export function OutlineCalendarclockIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.01304 15.0003H5.01144C3.90745 15.0003 3.01465 14.1075 3.01465 13.0035V8.00195H15.0146"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.01465 9.99805V11.0012"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M5.68335 12V12.9984"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M5.00184 5.00195H13.0274C14.1218 5.00195 15.0146 5.88995 15.0146 6.98915V8.00195H3.01465V6.98915C3.01465 5.89475 3.90265 5.00195 5.00184 5.00195Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M6.01465 5.0016V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M12.0146 5.0016V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M21.0148 16.5027C21.0148 19.5363 18.5524 21.9987 15.514 21.9987C12.4756 21.9987 10.0132 19.5363 10.0132 16.5027C10.0132 15.9843 10.0852 15.4803 10.2196 15.0003C10.57 13.7715 11.3284 12.7203 12.346 12.01C13.114 11.4628 14.026 11.1124 15.0148 11.026C15.178 11.0116 15.346 11.002 15.514 11.002C18.5524 11.002 21.0148 13.4643 21.0148 16.5027Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0146 13.9434V17.001H16.8482"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
